"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_inlinesvg_1 = __importDefault(require("react-inlinesvg"));
var mic_off_svg_1 = __importDefault(require("@lifesize/ux-assets/vectors/svgIcons/mic-off.svg"));
var AudioLevelIndicator_1 = __importDefault(require("./AudioLevelIndicator"));
var core_1 = require("@material-ui/core");
var ux_assets_1 = require("@lifesize/ux-assets");
function TileBar(_a) {
    var metadata = _a.metadata, _b = _a.show, show = _b === void 0 ? false : _b;
    var classes = useStyles({ show: show });
    var name = metadata.displayName || metadata.name;
    var hasAudioLevel = Object.prototype.hasOwnProperty.call(metadata, 'audioLevel');
    var audioMuted = metadata.audioPaused || metadata.audioMuted || metadata.localMuteState || metadata.serverMuteState;
    if (!metadata || Object.keys(metadata).length === 0)
        return react_1.default.createElement("div", null);
    return (react_1.default.createElement("div", { "data-testid": "video-title", className: classes.tileBar },
        react_1.default.createElement("div", { className: classes.audioHolder },
            audioMuted && react_1.default.createElement(react_inlinesvg_1.default, { "data-testid": "participant-mic-muted", src: mic_off_svg_1.default, className: classes.micOff }),
            !audioMuted && hasAudioLevel && (react_1.default.createElement(AudioLevelIndicator_1.default, { id: "audio-id-" + metadata.id, audioLevel: metadata.audioLevel }))),
        react_1.default.createElement("div", { "data-testid": "display-name", className: classes.displayName }, name),
        metadata.e2eeWord && react_1.default.createElement("div", { className: classes.e2eeWord }, metadata.e2eeWord)));
}
exports.default = TileBar;
var useStyles = core_1.makeStyles(function () { return ({
    tileBar: {
        alignItems: 'center',
        background: 'rgba(0,0,0,.5)',
        borderRadius: '0 0 5px 5px',
        bottom: 0,
        color: ux_assets_1.colors.white,
        display: 'flex',
        fontSize: '15px',
        height: '28px',
        opacity: function (props) { return (props.show ? 1 : 0); },
        position: 'absolute',
        transition: 'opacity .5s',
        width: '100%'
    },
    audioHolder: {
        alignItems: 'center',
        display: 'flex',
        flex: '0 0 auto',
        height: '100%',
        paddingLeft: '1rem'
    },
    micOff: {
        color: ux_assets_1.colors.alertRed,
        height: '100%',
        width: 'auto'
    },
    displayName: {
        flex: '1 1 auto',
        overflow: 'hidden',
        paddingLeft: '10px',
        textAlign: 'left',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    e2eeWord: {
        flex: '0 0 auto',
        paddingRight: '1rem',
        textAlign: 'right',
        whiteSpace: 'nowrap'
    },
    hideVideo: {
        display: 'none'
    }
}); });
